export const selectedIdsFrom = (rows)=>Object.entries(rows).filter((param)=>{
        let [, isSelected] = param;
        return isSelected;
    }).map((param)=>{
        let [id] = param;
        return id;
    });
export const selectedRowsFrom = (ids)=>Object.fromEntries(ids.map((id)=>[
            id,
            true
        ]));
export const tableSelectionFrom = (param)=>{
    let { selected, onSelectionChange } = param;
    return {
        selectedIds: new Set(selectedIdsFrom(selected)),
        onChange: (ids)=>onSelectionChange(selectedRowsFrom([
                ...ids
            ].map(String)))
    };
};
